import { createActionHelpers } from 'vuex-loading';
import Laroute from '../../laroute';
import axios from 'axios';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    shelfSpacePlanCount: [],
    productsPoolCount: null,
    categoryList: [],
    subCategoryList: [],
    shelfSpacePlanList: [],
};

const getters = {
    shelfSpacePlanCount: state => state.shelfSpacePlanCount,
    productsPoolCount: state => state.productsPoolCount,
    categoryList: state => state.categoryList,
    subCategoryList: state => state.subCategoryList,
    shelfSpacePlanList: state => state.shelfSpacePlanList,
};

const mutations = {
    setShelfSpacePlanCount(state, shelfSpacePlanCount) {
        state.shelfSpacePlanCount = shelfSpacePlanCount;
    },

    setProductsPoolCount(state, productsPoolCount) {
        state.productsPoolCount = productsPoolCount;
    },

    setCategoryList(state, categoryList) {
        state.categoryList = categoryList;
    },

    setSubCategoryList(state, subCategoryList) {
        state.subCategoryList = subCategoryList;
    },

    setShelfSpacePlanList(state, shelfSpacePlanList) {
        state.shelfSpacePlanList = shelfSpacePlanList;
    },
};

const actions = {
    async storeShelfSpacePlan({ commit, dispatch }, params) {
        const route = Laroute.route('franchise.shelf_space_plan.create');
        const loadingKey = 'save-shelf-space-plan';

        try {
            startLoading(dispatch, loadingKey);
            return await axios.post(route, params);
        } catch (err) {
            throw err;
        } finally {
            endLoading(dispatch, loadingKey);
        }
    },

    async deleteShelfSpacePlan({ commit, dispatch }, params) {
        const route = Laroute.route('franchise.shelf_space_plan.delete');
        const loadingKey = 'delete-shelf-space-plan';

        try {
            startLoading(dispatch, loadingKey);
            return await axios.post(route, params);
        } catch (err) {
            throw err;
        } finally {
            endLoading(dispatch, loadingKey);
        }
    },

    async getShelfSpacePlanCount({ commit, dispatch }, params) {
        const route = Laroute.route('franchise.shelf_space_plan.count');
        const loadingKey = 'get-shelf-space-plan-count';

        try {
            startLoading(dispatch, loadingKey);
            const { data } = await axios.post(route, params);
            commit('setShelfSpacePlanCount', data);
        } catch (err) {
            throw err;
        } finally {
            endLoading(dispatch, loadingKey);
        }
    },

    async getShelfSpacePlanProductsCount(
        { commit, dispatch },
        { shelfSpacePlanId, filters },
    ) {
        const route = Laroute.route(
            'franchise.shelf_space_plan.products_count',
            { id: shelfSpacePlanId },
        );
        const loadingKey = 'get-shelf-space-plan-products-count';

        try {
            startLoading(dispatch, loadingKey);
            const { data } = await axios.get(route, { params: filters });
            commit('setProductsPoolCount', data.count);
        } catch (err) {
            throw err;
        } finally {
            endLoading(dispatch, loadingKey);
        }
    },

    async getCategoryList({ commit, dispatch }, params) {
        const route = Laroute.route('franchise.shelf_space_plan.category');
        const loadingKey = 'get-category-list';

        try {
            startLoading(dispatch, loadingKey);
            const { data } = await axios.get(route, params);
            commit('setCategoryList', data);
        } catch (err) {
            throw err;
        } finally {
            endLoading(dispatch, loadingKey);
        }
    },

    async getSubCategoryList({ commit, dispatch }, params) {
        const route = Laroute.route('franchise.shelf_space_plan.sub_category');
        const loadingKey = 'get-sub-category-list';

        try {
            startLoading(dispatch, loadingKey);
            const { data } = await axios.get(route, params);
            commit('setSubCategoryList', data);
        } catch (err) {
            throw err;
        } finally {
            endLoading(dispatch, loadingKey);
        }
    },

    async getShelfSpacePlanList({ commit, dispatch }, outlet_id) {
        const route = Laroute.route('franchise.shelf_space_plan.list');
        const loadingKey = 'get-shelf-space-plan-list';

        try {
            startLoading(dispatch, loadingKey);
            const { data } = await axios.get(route, { params: { outlet_id } });
            commit('setShelfSpacePlanList', data);
        } catch (err) {
            throw err;
        } finally {
            endLoading(dispatch, loadingKey);
        }
    },

    async storeShelfSpacePlanProducts({ commit, dispatch }, params) {
        const route = Laroute.route(
            'franchise.shelf_space_plan.products_create',
        );
        const loadingKey = 'save-shelf-space-plan-products';

        try {
            startLoading(dispatch, loadingKey);
            return await axios.post(route, params);
        } catch (err) {
            throw err;
        } finally {
            endLoading(dispatch, loadingKey);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
